import { dbsKeys } from "data/dbsKeys";
import { seedDeals, seedProvinces } from "data/dbsSeed";

function safeParse(raw, fallback) {
  if (!raw) return fallback;
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function ensureSeed() {
  if (typeof window === "undefined") return;

  const hasProvinces = !!window.localStorage.getItem(dbsKeys.provinces);
  const hasDeals = !!window.localStorage.getItem(dbsKeys.deals);

  if (!hasProvinces) {
    window.localStorage.setItem(dbsKeys.provinces, JSON.stringify(seedProvinces));
  }
  if (!hasDeals) {
    window.localStorage.setItem(dbsKeys.deals, JSON.stringify(seedDeals));
  }
}

export function readCollection(key, fallback) {
  ensureSeed();
  return safeParse(window.localStorage.getItem(key), fallback);
}

export function writeCollection(key, value) {
  window.localStorage.setItem(key, JSON.stringify(value));
}

export function generateId(prefix) {
  return `${prefix}-${Math.random().toString(16).slice(2)}-${Date.now().toString(16)}`;
}
